import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function CategoriesSection() {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const categories = [
    { key: 'cat_shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', image: 'https://readdy.ai/api/search-image?query=Single%20white%20leather%20sneaker%20on%20light%20neutral%20pedestal%20minimalist%20product%20photography%20clean%20studio%20background%20soft%20shadow&width=600&height=600&seq=cat-shoes-01&orientation=squarish' },
    { key: 'cat_hoodies', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', image: 'https://readdy.ai/api/search-image?query=Folded%20beige%20oversized%20hoodie%20on%20wooden%20hanger%20against%20cream%20wall%20minimal%20streetwear%20product%20photo%20soft%20lighting&width=600&height=600&seq=cat-hoodies-01&orientation=squarish' },
    { key: 'cat_tshirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line', image: 'https://readdy.ai/api/search-image?query=Plain%20white%20cotton%20t-shirt%20neatly%20folded%20on%20light%20gray%20background%20minimal%20apparel%20product%20photography%20clean&width=600&height=600&seq=cat-tshirts-01&orientation=squarish' },
    { key: 'cat_jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-shirt-line', image: 'https://readdy.ai/api/search-image?query=Black%20bomber%20jacket%20on%20mannequin%20torso%20against%20light%20concrete%20wall%20studio%20fashion%20photography%20minimal&width=600&height=600&seq=cat-jackets-01&orientation=squarish' },
    { key: 'cat_pants', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-scissors-cut-line', image: 'https://readdy.ai/api/search-image?query=Pair%20of%20beige%20cargo%20pants%20flat%20lay%20on%20neutral%20linen%20background%20minimal%20fashion%20product%20shot%20soft%20light&width=600&height=600&seq=cat-pants-01&orientation=squarish' },
    { key: 'cat_headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-base-station-line', image: 'https://readdy.ai/api/search-image?query=Navy%20blue%20baseball%20cap%20on%20light%20wooden%20surface%20minimalist%20headwear%20product%20photography%20clean%20studio&width=600&height=600&seq=cat-headwear-01&orientation=squarish' },
    { key: 'cat_sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20outfit%20set%20of%20hoodie%20and%20joggers%20displayed%20on%20light%20background%20streetwear%20collection%20clean&width=600&height=600&seq=cat-sets-01&orientation=squarish' },
    { key: 'cat_underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line', image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20white%20cotton%20undershirts%20stacked%20on%20clean%20light%20surface%20minimal%20clothing%20product%20photo%20soft&width=600&height=600&seq=cat-underwear-01&orientation=squarish' },
    { key: 'cat_jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-2-line', image: 'https://readdy.ai/api/search-image?query=Colorful%20soccer%20jersey%20hanging%20on%20light%20background%20sportswear%20product%20photography%20clean%20studio%20bright%20colors&width=600&height=600&seq=cat-jersey-01&orientation=squarish' },
    { key: 'cat_accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-vip-diamond-line', image: 'https://readdy.ai/api/search-image?query=Minimal%20wristwatch%20and%20sunglasses%20arranged%20on%20light%20neutral%20surface%20premium%20accessories%20product%20photography%20soft&width=600&height=600&seq=cat-accessories-01&orientation=squarish' },
    { key: 'cat_bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-3-line', image: 'https://readdy.ai/api/search-image?query=Tan%20leather%20backpack%20on%20clean%20light%20background%20minimal%20bag%20product%20photography%20soft%20studio%20lighting%20warm&width=600&height=600&seq=cat-bags-01&orientation=squarish' },
    { key: 'cat_belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-circle-line', image: 'https://readdy.ai/api/search-image?query=Brown%20leather%20belt%20coiled%20neatly%20on%20light%20surface%20minimal%20fashion%20accessory%20product%20photo%20soft%20lighting&width=600&height=600&seq=cat-belts-01&orientation=squarish' },
    { key: 'cat_perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line', image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20on%20light%20marble%20surface%20luxury%20fragrance%20product%20photography%20soft%20lighting%20clean&width=600&height=600&seq=cat-perfumes-01&orientation=squarish' },
    { key: 'cat_other', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', image: 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20items%20flat%20lay%20on%20warm%20neutral%20background%20minimal%20ecommerce%20product%20photography%20clean%20studio&width=600&height=600&seq=cat-other-01&orientation=squarish' },
  ];

  const extraCategories = [
    { key: 'cat_fashion', icon: 'ri-store-line' },
    { key: 'cat_streetwear', icon: 'ri-fire-line' },
    { key: 'cat_sportswear', icon: 'ri-basketball-line' },
    { key: 'cat_electronics', icon: 'ri-smartphone-line' },
    { key: 'cat_home', icon: 'ri-home-smile-line' },
    { key: 'cat_popular', icon: 'ri-star-line' },
  ];

  return (
    <section id="categories" className="w-full bg-background-100 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 font-heading">
              {t('categories_title')}
            </h2>
            <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              {t('categories_subtitle')}
            </p>
          </div>

          {/* Dropdown selector */}
          <div className="mb-10 flex justify-center">
            <div className="relative w-full max-w-md">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-5 py-3.5 rounded-lg bg-white border border-background-200 hover:border-primary-300 text-foreground-950 font-medium transition-colors cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-list-check text-primary-500" />
                  {t('nav_categories')}
                </span>
                <i className={`ri-arrow-down-s-line transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-background-200 rounded-lg shadow-lg overflow-hidden z-30 max-h-72 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.key}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <i className={`${cat.icon} text-lg text-primary-500`} />
                      {t(cat.key)}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Category cards with images */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4 mb-10">
            {categories.map((cat) => (
              <a
                key={cat.key}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col overflow-hidden rounded-lg bg-white border border-background-200 hover:border-primary-300 transition-all text-center cursor-pointer"
              >
                <div className="w-full h-32 md:h-36 overflow-hidden">
                  <img
                    src={cat.image}
                    alt={t(cat.key)}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="flex items-center justify-center gap-1.5 px-2 py-3">
                  <i className={`${cat.icon} text-sm text-primary-500`} />
                  <span className="text-xs md:text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                    {t(cat.key)}
                  </span>
                </div>
              </a>
            ))}
          </div>

          {/* Extra category buttons */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
            {extraCategories.map((cat) => (
              <div
                key={cat.key}
                className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-white/60 border border-background-200 hover:border-accent-300 hover:bg-accent-50/30 transition-all text-center cursor-pointer"
              >
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                  <i className={`${cat.icon} text-lg text-accent-600`} />
                </div>
                <span className="text-xs font-medium text-foreground-800 group-hover:text-accent-700 transition-colors">
                  {t(cat.key)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}